<template>

  <div>
    <div class="row  no-gutters pt-xl-4 mb-xl-6">
      <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

      </div>
      <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
           v-if="lesson">
        {{ lesson.lesson }}
      </div>
      <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
        <div class="zerno-points">
          {{ points }}
        </div>
      </div>
      <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
        <div class="tab-video-notice-1">{{ $t('test') }} {{ $t('№') }}{{ test.pos }}
          <span class="ml-2" v-if="testsCount > 0">({{ test.pos }} {{ $t('of') }} {{ testsCount }})</span>
        </div>
      </div>

      <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

        <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
        <h2 class="mt-7" v-else>{{ $t('test') }} {{ $t('№') }}{{ test.pos }}</h2>
        <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
        <button
            class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
            @click="startTest">
          <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{ $t('№') }}{{ test.pos }}
        </button>

      </div>

      <div class="col-12 order-10" v-if="!showTestIntro && test">

        <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

          <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
               v-if="currentTask.testtask">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{ $t('№') }}{{ currentTask.pos }}.</span>{{ currentTask.testtask }}
          </div>

          <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
               v-if="test.description && test.description !== currentTask.testtask">{{
              test.description
            }}
          </div>

          <div class="offset-0 offset-xl-1 col-xl-10 col-12">
            <div class="row">
              <div v-for="(item,ind) in testelementsDropZone"
                   :key="'zone' + ind"
                   class="mb-3 pa-0 col-xl-4 col-6">
                <div :class="['h-100', 'test-drag-word-wrapper', 'mb-4', item.color]">
                  <div class="ma-0 pa-0">
                    <img :src="item.image"
                         class="ma-1 test-drag-word-image test-image single-image"/>
                    <container
                        group-name="col"
                        :should-accept-drop="(src, payload) => {log('accept ' + ind, src); return true /*testelementsDropZone[ind].child.length===0 || payload===testelementsDropZone[ind].child[0]*/}"
                        :get-child-payload="getCardPayload(ind)"
                        no-drag-class="card-ghost"
                        no-drop-class="card-ghost-drop"
                        :drop-placeholder="dropPlaceholderOptions"
                        class="text-center mx-auto"
                        style="height: 50px;"
                        @drop="(e) => onCardDrop(ind, e)"
                        @drag-start="(e) => log('drag start', e)"
                        @drag-end="(e) => log('drag end', e)">
                      <draggable
                          v-for="child in testelementsDropZone[ind].child"
                          :key="child.idtestelement"
                          @touchmove.native="draggableMove">
                        <div class="ma-3 py-4">
                          <div class="btn btn-secondary test-question-btn test-drag-word px-0">
                            {{ child.word }}
                          </div>
                        </div>
                      </draggable>
                    </container>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
      <button
          class="btn btn-info"
          @click="skip"
      >
        {{ $t('omit_task') }} &rarr;
      </button>
    </div>
  </div>


</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<script>
import api from '@/utils/api'
import {Container, Draggable} from 'vue-smooth-dnd'

export default {
  name: 'Test3',
  components: {
    Container,
    Draggable,
  },
  props: {
    idtest: {default: null},
    lesson: {type: Object, default: null},
    points: {default: null},
    testsCount: {default: null},
    showButtons: {type: Boolean, default: true},
    testmode: {default: 0},
  },
  data: () => ({
    test: {},
    testtasks: [],
    testelements: [],
    taskIdx: 0,
    audio: new Audio(),

    testelementsDropZone: [],

    forceRenderKey: 0,

    upperDropPlaceholderOptions: {
      className: 'cards-drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },
    dropPlaceholderOptions: {
      className: 'drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },

    showTestIntro: true,
    //errorChord: 'gong.mp3',
    errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
    okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
  }),

  computed: {
    currentTask: function () {
      // console.log('currentTask')
      return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
    },
  },

  watch: {
    taskIdx: function () {
      this.loadTask()
    },
  },

  async mounted() {
    // console.log('mounted')
    api({url: '/tests/' + this.idtest}).then(resp => {
      this.test = resp.data
    })
    const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
    this.testtasks = response.data
    console.log(this.currentTask, this.taskIdx)
    // workaround for "once smooth-dnd is touched, can not scroll any more page" https://github.com/kutlugsahin/smooth-dnd/issues/83#issuecomment-713486752
    const cleanClasses = () => {
      document.body.className = '';
    };
    document.addEventListener('touchend', cleanClasses, false);
  },

  methods: {
    async startTest() {
      if (this.testtasks.length) {
        if (this.test.audio) {
          await this.play(this.test.audio)
        }
        this.showTestIntro = false
        this.loadTask()
      }
    },
    async loadTask() {
      if (this.currentTask.idtesttask) {
        console.log('loadTask')
        this.testelementsDropZone = []
        const response = await api({
          method: 'get',
          url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
        })
        this.testelements = response.data

        for (let index = 0; index < this.testelements.length; index++) {
          this.testelementsDropZone.push({
            idtestelement: this.testelements[index].idtestelement,
            audio: this.testelements[index].audio,
            image: this.testelements[index].image,
            child: []
          })
        }

        this.testelements = this.shuffleFull(this.testelements)
        for (let index = 0; index < this.testelementsDropZone.length; index++) {
          this.testelementsDropZone[index].child = [this.testelements[index]]
        }
      } else {
        this.$emit('testComplete')
      }
    },

    getBy(propname, value, array) {
      for (let index = 0; index < array.length; index++) {
        if (array[index][propname] === value) return array[index]
      }

      return {}
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
      }
      return a
    },

    shuffleFull(items) {
      const originalState = items.map(a => ({...a})) // clone

      for (let i = 0; i < 1000; i++) {
        items = this.shuffle(items)
        let wrongPlace = false
        items.forEach((e, i) => {
          if (e.idtestelement === originalState[i].idtestelement) wrongPlace = true
        })
        if (!wrongPlace) {
          console.log('Shuffle tryes: ' + i)
          break
        }
      }

      return items
    },

    play: function (path) {
      return new Promise((resolve) => {
        if (path) {
          this.audio.src = path
          this.audio.play()
          this.audio.onended = function () {
            console.log('Звук закончился')
            resolve()
          }

          this.audio.onerror = function () {
            console.log('Звук error')
            resolve()
          }
        } else {
          resolve()
        }
      })
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    skip: function () {
      this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
      this.taskIdx++
    },

    next: async function () {
      await this.sleep(1500)
      this.$emit('correctAnswer')
      this.taskIdx++
      console.log('taskIdx', this.taskIdx)
    },


    async onCardDrop(zoneIdx, dropResult) {
      console.log('drop ' + zoneIdx, dropResult, this.testelementsDropZone)

      // Что-то бросили в контейнер. Ищем контейнер в котором была эта карта и меняем содержимое местами
      if (dropResult.addedIndex !== null) {
        for (const i in this.testelementsDropZone) {
          if (this.testelementsDropZone[i].child.indexOf(dropResult.payload) > -1) {
            this.testelementsDropZone[i].child = this.testelementsDropZone[zoneIdx].child
            this.testelementsDropZone[zoneIdx].child = [dropResult.payload]

            this.testelementsDropZone[i].color = (this.testelementsDropZone[i].child[0].idtestelement === this.testelementsDropZone[i].idtestelement) ? 'green' : 'white'
            this.testelementsDropZone[zoneIdx].color = (this.testelementsDropZone[zoneIdx].child[0].idtestelement === this.testelementsDropZone[zoneIdx].idtestelement) ? 'green' : 'white'

            if (this.testelementsDropZone[zoneIdx].color === 'green') {
              if (this.testelementsDropZone[zoneIdx].audio) {
                await this.play(this.testelementsDropZone[zoneIdx].audio)
              } else {
                await this.play(this.okChord)
              }
            } else {
              await this.play(this.errorChord)
            }
            break
          }
        }

        let complete = !!this.testelementsDropZone.length
        this.testelementsDropZone.forEach(function (zone) {
          if (zone.color !== 'green') complete = false
        })
        console.log('checkOnDrop', this.testelementsDropZone)
        if (complete) this.next()
      }

    },
    getCardPayload(zoneIdx) {
      // console.log('getCardPayload', zoneIdx)
      return index => {
        return this.testelementsDropZone[zoneIdx].child[index]
      }
    },
    dragStart() {
      //console.log('drag started')
    },
    log(...params) {
      console.log(...params)
    },

    applyDrag(arr, dragResult) {
      const {removedIndex, addedIndex, payload} = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },

    draggableMove(e) {
      // Для автопрокрутки страницы на малых экранах, когда обсласти Drag&Drop не помещаются
      const offset = 50
      const scrollStep = 20
      const clientY = e.touches[0].clientY
      const viewportHeight = document.documentElement.clientHeight;
      if (clientY > (viewportHeight - offset))
        window.scrollBy(0, scrollStep);
      if (clientY < offset)
        window.scrollBy(0, -scrollStep);
    },
  },
}
</script>

<style>

.form-ghost {
  transition: 0.18s ease;
  box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.08);
}

.form-ghost-drop {
  box-shadow: 0 0 2px 5px rgba(0, 0, 0, 0.0);
}

.drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px;
}

.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px 45px 5px 5px;
}
</style>
